import React from 'react';

import List, {ListItem, ListItemSecondaryAction, ListItemText} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Grid from 'material-ui/Grid';
import Button from 'material-ui/Button';

import { MoreHoriz } from 'material-ui-icons';

import moment from 'moment-timezone';
import tsl from './../../../tsl';

export default class FlightItem extends React.Component {

	render() {
		const flight = this.props.flight;

		let startTime = moment(flight.start_time);
        const displayedBookings = this.props.showBookingInfo;
        const flight_offer = flight.aircraft_offer.flight_offer;

        const secondaryInfo = 
       		<span>
	        	<i className="zmdi zmdi-time"></i>
	        	{' ' + startTime.format('lll')}
	            <br />
	            <i className="zmdi zmdi-pin"></i>
	            {' ' + flight.location.name}
         	</span>;

        let bookingsInfo;
        if (displayedBookings) {
	        if (flight.bookings.length > 0) {
		        const bookingIcon = flight.bookings[0].is_exclusive 
		                    ? <i className="zmdi zmdi-bookmark" style={{color: "gold"}}></i>
		                    : <i className="zmdi zmdi-bookmark-outline"></i>;
		        
		        const bookingText = flight.bookings[0].is_exclusive
		                    ? tsl('flights.list.exclusive')
		                    : tsl('flights.list.bookings_count', { number: flight.bookings.length });

		        const all_passengers_count = flight.bookings
		                                    .map(i => i.passengers.length)  // convert bookings to count of passengers
		                                    .reduce((result, pass) => result + pass)    // sum all items in array

		    	bookingsInfo =
					<span>
		                    {bookingIcon} {' ' + bookingText}{' '}{
						flight.bookings.map((b, i) => <strong
							className="text-primary">{i !== 0 ? ', ' : ''}#{b.id}</strong>)
					}<br/>
		                    <i className="zmdi zmdi-accounts"></i> {' ' + all_passengers_count}
						{tsl('flights.list.min_passengers', {number: flight.aircraft_offer.passengers_min})}
						{' '} <i className="zmdi zmdi-airline-seat-recline-extra"></i>
						{' ' + flight.aircraft_offer.passengers_capacity}
						{flight.bookings[0].is_exclusive && flight.bookings.length > 1 &&
							<div>
								{' '} <img src="./assets/images/mas-cashback.png" width={20} alt="cashback" title="cashback"/>
							</div>
						}
		                </span>

			} else {
				bookingsInfo =
					<span>
		    			{'- no bookings -'} <br />
		    			<i className="zmdi zmdi-airline-seat-recline-extra"></i>
		    			{' ' + flight.aircraft_offer.passengers_capacity}
		    		</span>;
		    }
		}
	    
	    const aircraftStyle = flight.aircraft && flight.aircraft.calendar
    				? { color: flight.aircraft.calendar.color_hex }
    				: {};

	    return (<div>
	        <ListItem button
	             onClick={this.props.onListItemClick}
	        >
	            {this.props.renderStatusIconFnc(flight.status)}
	            
	            <Grid container spacing={0}>
	                <Grid item xs={12} sm={6}>
	                    <ListItemText className="br-break"
	                        primary={flight_offer.title}
	                        secondary={secondaryInfo}
	                    />
	                </Grid>
	                <Grid item xs={12} sm={6}>
	                    <ListItemText className="br-break"
	                    	primary={
	                    		<span>
		                    		<i className="zmdi zmdi-airplane" />
		                    		{' '}{(flight.aircraft ? <span style={aircraftStyle}>{flight.aircraft.reg_no}</span> : '-')}
		                    		{' ('+flight.aircraft_model.name+')'}
	                    		</span>}
	                        secondary={bookingsInfo}
	                    />
	                </Grid>
	            </Grid>
                {!this.props.onMoreClick ? '' : 
    	            <ListItemSecondaryAction>
    	                <Button color="primary" className="jr-btn"
    	                    onClick={this.props.onMoreClick}
                            style={this.props.moreBtnStyle || {}}
    	                >
    	                    {this.props.moreBtn ? this.props.moreBtn : <MoreHoriz />}
    	                </Button>
    	            </ListItemSecondaryAction>
                }
	        </ListItem>

	        <Divider />
	    </div>
	    );
	}
}


// WEBPACK FOOTER //
// ./app/used/flights/routes/FlightItem.js